import { useState, useEffect } from 'react';

const WHATSAPP_URL = 'https://wa.me/5519988179126?text=Ol%C3%A1!%20Gostaria%20de%20agendar%20uma%20visita%20%C3%A0%20Escola%20Turminha%20da%20Alegria.';

const navLinks = [
  { label: 'A Escola', href: '#sobre' },
  { label: 'Metodologia', href: '#metodologia' },
  { label: 'Turmas', href: '#turmas' },
  { label: 'Galeria', href: '#galeria' },
  { label: 'Contato', href: '#contato' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2 cursor-pointer">
          <h1>
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/dbb91ed3e4be9c76a73c295c28ca35e3.png"
              alt="Escola Infantil Turminha da Alegria – Campinas"
              className="h-[92px] w-auto object-contain"
            />
          </h1>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNav(link.href)}
              className={`font-body font-700 text-[15px] transition-colors duration-200 cursor-pointer whitespace-nowrap hover:text-azul-medio ${
                scrolled ? 'text-[#0D0D0D]' : 'text-white drop-shadow'
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* CTA Button */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden lg:flex items-center gap-2 bg-vermelho text-white font-body font-700 text-sm px-5 py-2.5 rounded-full hover:bg-red-600 transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-lg" />
          Agendar Visita
        </a>

        {/* Mobile Menu Button */}
        <button
          className={`lg:hidden text-2xl cursor-pointer ${scrolled ? 'text-azul-escuro' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4 animate-fade-in">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNav(link.href)}
              className="font-body font-700 text-[#0D0D0D] text-base text-left py-2 border-b border-gray-50 hover:text-azul-medio transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-vermelho text-white font-body font-700 text-sm px-5 py-3 rounded-full hover:bg-red-600 transition-all cursor-pointer whitespace-nowrap mt-2"
          >
            <i className="ri-whatsapp-line text-lg" />
            Agendar Visita
          </a>
        </div>
      )}
    </header>
  );
}
